import { DataActions } from './constants';
import { Order } from './dataProvider';
import * as storage from '../../utils/storage';
import { omit } from 'lodash';

import { replace } from '../../utils';
import { gridPrefix } from './gridUtils';

const commonProps = {
  url: null,
  items: [],
  count: 0,
  loading: false,
  filters: [],
  sort: null,
  order: Order.DESC,
  pageSize: 10,
  filterOpen: false,
  page: 0,
};

const dataReducer = (state, action) => {
  switch (action.type) {
    case DataActions.INIT: {
      const newState = {
        ...commonProps,
        ...action.defaultProps,
        loading: true,
      };
      if (state && state.items && state.items.length > 0 &&
          state.url === newState.url &&
          JSON.stringify(state.query) === JSON.stringify(newState.query) &&
          JSON.stringify(state.items) === JSON.stringify(newState.items)) {
        return {
          ...newState,
          items: state.items,
          count: state.count,
          loading: false,
        };
      }
      return newState;
    }
    case DataActions.SET_ITEMS:
      return {
        ...state,
        ...action.payload,
        loading: false
      };
    case DataActions.LOAD:
      return {
        ...state,
        items: action.items,
        count: action.count,
        loading: false
      };
    case DataActions.FILTER_REMOVE:
      return {
        ...state,
        filters: state.filters.filter(filter => filter !== action.filter),
      };
    case DataActions.FILTER_RESET_VALUE:
      return {
        ...state,
        filters: state.filters.map(filter => ({ ...filter, value: action.filter === filter ? '' : filter.value, operation: action.filter === filter ? null : filter.operation })),
      };
    case DataActions.FILTER_RESET_VALUES:
      return {
        ...state,
        filters: state.filters.map(filter => ({ ...filter, value: '' })),
      };
    case DataActions.FILTER_EDIT:
      return {
        ...state,
        filters: replace(state.filters, action.filter, action.newFilter),
      };
    case DataActions.FILTER_ADD:
      return {
        ...state,
        filters: [...state.filters, { field: null, operation: null, value: '' }],
      };
     case DataActions.FILTER_DEFAULT:
      const fields = state.filters.map(f2 => f2.field);
      return {
        ...state,
        filters: [...state.filters, ...action.filters.filter(f => !fields.includes(f.field))],
      };
    case DataActions.SORT:
      return {
        ...state,
        sort: action.sort,
      };
    case DataActions.ORDER:
      return {
        ...state,
        order: action.order,
      };
    case DataActions.PAGE_SIZE:
      return {
        ...state,
        pageSize: action.pageSize,
        page: 0,
      };
    case DataActions.FILTER_OPEN:
      return {
        ...state,
        filterOpen: action.isOpen,
      };
    case DataActions.PAGE:
      return {
        ...state,
        page: action.page,
      };
    default:
      return state;
  }
};

export default (state = {}, action) => {
  switch (action.type) {
    case DataActions.INIT:
    case DataActions.SET_ITEMS:
    case DataActions.LOAD:
    case DataActions.FILTER_REMOVE:
    case DataActions.FILTER_RESET_VALUE:
    case DataActions.FILTER_RESET_VALUES:
    case DataActions.FILTER_EDIT:
    case DataActions.FILTER_ADD:
    case DataActions.FILTER_DEFAULT:
    case DataActions.SORT:
    case DataActions.ORDER:
    case DataActions.PAGE_SIZE:
    case DataActions.PAGE:
    case DataActions.FILTER_OPEN:
      const newState = dataReducer(state[action.dataId], action);
      storage.safePut(gridPrefix + action.dataId, omit(newState, ['count', 'url', 'items', 'query']));
      return {
        ...state,
        [action.dataId]: newState,
      };
    default:
      return state;
  }
};
